<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <page-header class="py-4 pb-6">
      {{ $t('ClassificationStatistics') }}
    </page-header>
    <loading-provider
      :loading="loading"
    >
      <v-card
        class="d-flex flex-column justify-end"
        color="transparent"
        elevation="0"
        style="position:relative"
        tile
      >
        <apex-chart
          v-if="graphIsReady"
          :options="options"
          :series="series"
          height="350"
          type="bar"
        />
      </v-card>
    </loading-provider>
  </div>
</template>

<script>

import { getCategoryReport } from '@/model/dataLayer/api/statistic/categoryReport'
import { sortBy } from 'lodash-es'
import pageHeader from '@/views/widget/typography/PageHeader'
import LoadingProvider from '@/views/widget/LoadingProvider'
import { formatPrice } from '@/model/utils/formatPrice'

export default {
  name: 'CategoryReport',
  components: {
    LoadingProvider,
    pageHeader
  },
  data: function () {
    return {
      loading: false,
      series: [],
      options: {},
      graphIsReady: false
    }
  },
  watch: {
    '$parent.dateRange': {
      handler: function (val) {
        this.initGraph()
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    this.initGraph()
  },
  methods: {
    initGraph: async function () {
      this.loading = true
      this.graphIsReady = false
      let res = (await getCategoryReport(this.$parent.dateRange))
      res = sortBy(res, function (x) { return parseFloat(-x.sumTotal) })
      const result = []
      for (const item of res) {
        console.log(item.sumTotal)
        result.push({ name: item._langsname, value: item.sumTotal })
      }
      const data = result.map(it => {
        return {
          x: it.name,
          y: (it.value)
        }
      })
      this.series = [
        {
          name: '销售额',
          data
        }
      ]

      this.options = {
        fill: {
          colors: [
            '#245df7'
          ]
        },
        plotOptions: {
          bar: {
            columnWidth: '90%',
            distributed: true,
            horizontal: true
          }
        },
        chart: {
          toolbar: {
            show: false
          }

        },

        grid: {
          show: false
        },
        legend: {
          show: false
        },
        dataLabels: {
          enabled: false
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: formatPrice
          }
        },
        yaxis: {
          show: true,
          axisBorder: {
            show: false
          }
        },
        xaxis: {
          show: false,
          type: 'category',
          labels: {
            formatter: formatPrice
          },
          axisTicks: {
            show: false
          }
        }

      }
      this.graphIsReady = true
      this.loading = false
    }
  }
}
</script>

<style scoped>

</style>
